export const FOREGROUND_SCALE = 0.7;
export const FOREGROUND_Y_OFFSET_RATIO = 0.2;
